export type AtlasThemeMode = 'dark' | 'light';

export const atlasColorTokens = {
	dark: {
		accent: {
			primary: '#345CF8',
			primaryHover: '#2a4be0',
			primarySoft: '#748cf6',
			primaryAlt: '#3260ed',
			primaryGlow: 'rgb(39 95 240)',
			primaryGlowAlpha10: 'rgba(39, 95, 241, 0.1)',
			primaryGlowAlpha20: 'rgba(39, 95, 241, 0.2)',
			info: '#1996e0',
			infoAlpha20: 'rgba(25, 150, 224, 0.2)',
			success: '#4caf50',
			successAlt: 'rgb(28 169 117)',
			successAlpha10: 'rgba(76, 175, 80, 0.1)',
			navActive: '#2960F8',
			walletAccent: '#f6851a',
			purple: 'rgb(157 105 246)',
		},
		background: {
			app: '#070811',
			appAlt: '#070911',
			appDeep: '#080913',
			surface: 'rgba(14, 16, 27, 0.58)',
			surfaceAlt: '#0a0b14',
			surfaceStrong: '#0f172a',
			surfaceSelected: '#11141f',
			surfaceRaised: '#10121d',
			surfaceAccent: '#152243',
			surfaceInteractive: '#172343',
			surfaceHover: '#1d2433',
			surfaceMuted: '#202231',
			surfaceAlpha60: 'rgba(14, 16, 27, 0.6)',
			card: '#2e2f3a',
			dropdown: '#1A1A33',
			dropdownHover: '#505050',
			light: '#f1f5f9',
			lightStrong: '#F4F3F1',
			lightTranslucent: '#f4f3f1c9',
			disabled: '#a6a6a6',
			white: '#fff',
		},
		border: {
			default: '#3a3d49',
			muted: '#3a3d48',
			subtle: '#2a2d36',
			strong: '#353843',
			soft: '#d9d9da',
			contrast: '#666677',
			deep: '#1b1c26',
			dark: '#3b3d43',
			accent: '#223256',
			accentAlt: '#2f3b5f',
			accentStrong: '#1c243a',
			light: '#e0e0e0',
			neutral: 'rgb(138, 140, 146)',
		},
		text: {
			primary: '#fff',
			inverse: '#0e101b',
			dark: '#000',
			darkStrong: '#000000',
			muted: '#7d7e84',
			mutedAlt: '#7b7b88',
			mutedStrong: '#71727d',
			subtle: '#8a8f9c',
			subtleAlt: '#989ca3',
			disabled: '#9f9fa1',
			light: '#94a3b8',
			lightStrong: '#475569',
			faint: '#555',
			faintStrong: '#222',
			nav: '#3A3A3A',
			highlight: '#cfd6ff',
			placeholder: '#aaa',
			navy: '#091826',
		},
		overlay: {
			shadow: 'rgba(0, 0, 0, 0.1)',
			neutral: 'rgba(15, 23, 42, 0.08)',
			slateAlpha35: 'rgba(148, 163, 184, 0.35)',
			slateAlpha40: 'rgba(148, 163, 184, 0.4)',
			slateAlpha08: 'rgba(15, 23, 42, 0.08)',
			slateAlpha12: 'rgba(15, 23, 42, 0.12)',
			slateAlpha20: 'rgba(15, 23, 42, 0.2)',
			slateAlpha90: 'rgba(15, 23, 42, 0.9)',
			whiteSolid: '#ffffff',
		},
		google: {
			blue: '#4285F4',
			green: '#34A853',
			yellow: '#FBBC05',
			red: '#EA4335',
		},
		slack: {
			success: '#36a64f',
			error: '#ff0000',
		},
	},
	light: {
		accent: {
			primary: '#345CF8',
			primaryHover: '#2a4be0',
			primarySoft: '#748cf6',
			primaryAlt: '#3260ed',
			primaryGlow: 'rgb(39 95 240)',
			primaryGlowAlpha10: 'rgba(39, 95, 241, 0.1)',
			primaryGlowAlpha20: 'rgba(39, 95, 241, 0.2)',
			info: '#1996e0',
			infoAlpha20: 'rgba(25, 150, 224, 0.2)',
			success: '#4caf50',
			successAlt: 'rgb(28 169 117)',
			successAlpha10: 'rgba(76, 175, 80, 0.1)',
			navActive: '#2960F8',
			walletAccent: '#f6851a',
			purple: 'rgb(157 105 246)',
		},
		background: {
			app: '#f8fafc',
			appAlt: '#f1f5f9',
			appDeep: '#e2e8f0',
			surface: '#ffffff',
			surfaceAlt: '#f1f5f9',
			surfaceStrong: '#e2e8f0',
			surfaceSelected: '#e2e8f0',
			surfaceRaised: '#ffffff',
			surfaceAccent: '#e8f0ff',
			surfaceInteractive: '#edf2ff',
			surfaceHover: '#e2e8f0',
			surfaceMuted: '#f1f5f9',
			surfaceAlpha60: 'rgba(255, 255, 255, 0.6)',
			card: '#ffffff',
			dropdown: '#ffffff',
			dropdownHover: '#f1f5f9',
			light: '#ffffff',
			lightStrong: '#f1f5f9',
			lightTranslucent: 'rgba(255, 255, 255, 0.8)',
			disabled: '#cbd5e1',
			white: '#fff',
		},
		border: {
			default: '#e2e8f0',
			muted: '#e2e8f0',
			subtle: '#edf2f7',
			strong: '#cbd5e1',
			soft: '#cbd5e1',
			contrast: '#94a3b8',
			deep: '#cbd5e1',
			dark: '#cbd5e1',
			accent: '#c7d7ff',
			accentAlt: '#b6c8ff',
			accentStrong: '#9bb6ef',
			light: '#e0e0e0',
			neutral: '#94a3b8',
		},
		text: {
			primary: '#0f172a',
			inverse: '#ffffff',
			dark: '#0f172a',
			darkStrong: '#0f172a',
			muted: '#475569',
			mutedAlt: '#64748b',
			mutedStrong: '#334155',
			subtle: '#64748b',
			subtleAlt: '#94a3b8',
			disabled: '#94a3b8',
			light: '#475569',
			lightStrong: '#0f172a',
			faint: '#64748b',
			faintStrong: '#334155',
			nav: '#0f172a',
			highlight: '#1e293b',
			placeholder: '#94a3b8',
			navy: '#091826',
		},
		overlay: {
			shadow: 'rgba(15, 23, 42, 0.12)',
			neutral: 'rgba(15, 23, 42, 0.08)',
			slateAlpha35: 'rgba(148, 163, 184, 0.35)',
			slateAlpha40: 'rgba(148, 163, 184, 0.4)',
			slateAlpha08: 'rgba(15, 23, 42, 0.08)',
			slateAlpha12: 'rgba(15, 23, 42, 0.12)',
			slateAlpha20: 'rgba(15, 23, 42, 0.2)',
			slateAlpha90: 'rgba(15, 23, 42, 0.9)',
			whiteSolid: '#ffffff',
		},
		google: {
			blue: '#4285F4',
			green: '#34A853',
			yellow: '#FBBC05',
			red: '#EA4335',
		},
		slack: {
			success: '#36a64f',
			error: '#ff0000',
		},
	},
} as const;

export type AtlasColors = (typeof atlasColorTokens)[AtlasThemeMode];
